<template>
  <section
    v-if="codProducao && producao"
    class="wrapper"
    :class="isFullScreen ? 'justify-center align-center' : ''"
    :style="getBackgroundColor()"
  >
    <div v-if="mountTarja" style="width: 100%" class="tarjaRow">
      <component
        v-for="card in this.cardOnView"
        :key="`${card.id}-${isQRCodeMode}-${isFullScreen}`"
        v-bind:is="card.component"
        v-bind="card.options"
      />
    </div>
  </section>
</template>

<script>
import { apiClient } from "@/services/api";
import {
  ENQUETE_COMPONENT_MAP,
  DEFAULT_ENQUETE_COMPONENTS,
} from "@/config/enqueteComponentMap";
// Default
import CardTarjaEnqueteDefault from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefault.vue";
import CardTarjaEnqueteDefaultQRCODE from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefaultQRCODE.vue";
// SaiaJusta
import CardTarjaEnqueteSaiaJusta from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJusta.vue";
import CardTarjaEnqueteSaiaJustaFullscreen from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJustaFullscreen.vue";
import CardTarjaEnqueteSaiaJustaQRCODE from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJustaQRCODE.vue";
// AngelicaAoVivo
import CardTarjaEnqueteAngelica from "@/components/Cards/Enquetes/Tarjas/AngelicaAoVivo/CardTarjaEnqueteAngelica.vue";
import CardTarjaEnqueteAngelicaQRCODE from "@/components/Cards/Enquetes/Tarjas/AngelicaAoVivo/CardTarjaEnqueteAngelicaQRCODE.vue";
// SelecaoSportv
import CardTarjaEnqueteSelecaoSportv from "@/components/Cards/Enquetes/Tarjas/SelecaoSportv/CardTarjaEnqueteSelecaoSportv.vue";
import CardTarjaEnqueteSelecaoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/SelecaoSportv/CardTarjaEnqueteSelecaoSportvQRCODE.vue";
// CopaTVFechada
import CardTarjaEnqueteCopaTVFechada from "@/components/Cards/Enquetes/Tarjas/CopaTVFechada/CardTarjaEnqueteCopaTVFechada.vue";
import CardTarjaEnqueteCopaTVFechadaQRCODE from "@/components/Cards/Enquetes/Tarjas/CopaTVFechada/CardTarjaEnqueteCopaTVFechadaQRCODE.vue";
// SportTVNews
import CardTarjaEnqueteSportTVNews from "@/components/Cards/Enquetes/Tarjas/SportTVNews/CardTarjaEnqueteSportTVNews.vue";
import CardTarjaEnqueteSportTVNewsQRCODE from "@/components/Cards/Enquetes/Tarjas/SportTVNews/CardTarjaEnqueteSportTVNewsQRCODE.vue";
// TaNaAreaSportv
import CardTarjaEnqueteTaNaAreaSportv from "@/components/Cards/Enquetes/Tarjas/TaNaAreaSportv/CardTarjaEnqueteTaNaAreaSportv.vue";
import CardTarjaEnqueteTaNaAreaSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/TaNaAreaSportv/CardTarjaEnqueteTaNaAreaSportvQRCODE.vue";
// TrocaDePassesSportv
import CardTarjaEnqueteTrocaDePassesSportv from "@/components/Cards/Enquetes/Tarjas/TrocaDePassesSportv/CardTarjaEnqueteTrocaDePassesSportv.vue";
import CardTarjaEnqueteTrocaDePassesSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/TrocaDePassesSportv/CardTarjaEnqueteTrocaDePassesSportvQRCODE.vue";
// Ta On
import CardTarjaEnqueteTaOn from "@/components/Cards/Enquetes/Tarjas/TaOn/CardTarjaEnqueteTaOn.vue";
import CardTarjaEnqueteTaOnQRCODE from "@/components/Cards/Enquetes/Tarjas/TaOn/CardTarjaEnqueteTaOnQRCODE.vue";
// F1Sportv
import CardTarjaEnqueteF1Sportv from "@/components/Cards/Enquetes/Tarjas/F1Sportv/CardTarjaEnqueteF1Sportv.vue";
import CardTarjaEnqueteF1SportvQRCODE from "@/components/Cards/Enquetes/Tarjas/F1Sportv/CardTarjaEnqueteF1SportvQRCODE.vue";
// FechamentoSportv
import CardTarjaEnqueteFechamentoSportv from "@/components/Cards/Enquetes/Tarjas/FechamentoSportv/CardTarjaEnqueteFechamentoSportv.vue";
import CardTarjaEnqueteFechamentoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/FechamentoSportv/CardTarjaEnqueteFechamentoSportvQRCODE.vue";
// RedacaoSportv
import CardTarjaEnqueteRedacaoSportv from "@/components/Cards/Enquetes/Tarjas/RedacaoSportv/CardTarjaEnqueteRedacaoSportv.vue";
import CardTarjaEnqueteRedacaoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/RedacaoSportv/CardTarjaEnqueteRedacaoSportvQRCODE.vue";
// TVZ
import CardTarjaEnqueteTVZ from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZ.vue";
import CardTarjaEnqueteTVZFullScreen from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZFullScreen.vue";

export default {
  name: "EnqueteView",
  data() {
    return {
      codProducao: null,
      mountTarja: false,
      producao: {},
      cacheProducao: {},
      enqueteData: null,
      cacheEnqueteData: null,
      pollInterval: null,
      requestInterceptorId: null,
      isFetchingData: false,
    };
  },
  components: {
    CardTarjaEnqueteDefault,
    CardTarjaEnqueteDefaultQRCODE,
    CardTarjaEnqueteSaiaJusta,
    CardTarjaEnqueteSaiaJustaFullscreen,
    CardTarjaEnqueteSaiaJustaQRCODE,
    CardTarjaEnqueteAngelica,
    CardTarjaEnqueteAngelicaQRCODE,
    CardTarjaEnqueteSelecaoSportv,
    CardTarjaEnqueteSelecaoSportvQRCODE,
    CardTarjaEnqueteSportTVNews,
    CardTarjaEnqueteSportTVNewsQRCODE,
    CardTarjaEnqueteTaNaAreaSportv,
    CardTarjaEnqueteTaNaAreaSportvQRCODE,
    CardTarjaEnqueteTrocaDePassesSportv,
    CardTarjaEnqueteTrocaDePassesSportvQRCODE,
    CardTarjaEnqueteFechamentoSportv,
    CardTarjaEnqueteFechamentoSportvQRCODE,
    CardTarjaEnqueteRedacaoSportv,
    CardTarjaEnqueteRedacaoSportvQRCODE,
    CardTarjaEnqueteTVZ,
    CardTarjaEnqueteTVZFullScreen,
    CardTarjaEnqueteF1Sportv,
    CardTarjaEnqueteF1SportvQRCODE,
    CardTarjaEnqueteTaOn,
    CardTarjaEnqueteTaOnQRCODE,
    CardTarjaEnqueteCopaTVFechada,
    CardTarjaEnqueteCopaTVFechadaQRCODE,
  },
  created() {
    if (!this.$store.state.users.isAuthenticated) {
      this.requestInterceptorId = apiClient.interceptors.request.use(
        (config) => {
          const token = this.$route.query.token || null;

          if (token) {
            config.headers["x-access-token"] = token;
          }
          return config;
        },
        (error) => {
          console.error(error);
          return Promise.reject(error);
        }
      );
    }

    const selectedProduction = this.getSafeLocalStorage(
      "@socialcam/selected_option_production"
    );
    if (selectedProduction == null && this.$route.query.cod_producao == null) {
      this.$router.push({ name: "login" });
      return;
    }

    this.getFromApi();
    this.pollInterval = setInterval(this.getFromApi, 2000);
  },
  beforeDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
    if (this.requestInterceptorId !== null) {
      apiClient.interceptors.request.eject(this.requestInterceptorId);
      this.requestInterceptorId = null;
    }
  },
  computed: {
    componentMap() {
      return ENQUETE_COMPONENT_MAP;
    },
    defaultComponents() {
      return DEFAULT_ENQUETE_COMPONENTS;
    },
    cardOnView() {
      return [
        {
          id: 1,
          component: this.renderMode,
          options: {
            item: this.enqueteData,
            posicaoEnquete: this.posicaoEnqueteTarja,
            posicaoCard: this.posicaoEnqueteTarja,
            isFullScreen: this.isFullScreen,
            hideTitle: this.hideEnqueteTitle,
            hideOptionTitle: this.hideEnqueteOptionTitle,
          },
        },
      ];
    },
    renderMode() {
      let mode = "default";

      if (this.isQRCodeCombinedMode && (this.isQRCodeMode || this.isTarjaMode)) {
        mode = "combined";
      } else if (this.isQRCodeMode && !this.isTarjaMode) {
        mode = "qrcode";
      } else if (this.isFullScreen) {
        mode = "fullscreen";
      }

      const programComponents = this.componentMap[this.codProducao];

      if (programComponents && mode in programComponents) {
        const modeValue = programComponents[mode];

        if (modeValue === null || modeValue === false) {
          return this.defaultComponents[mode] || this.defaultComponents["default"];
        }

        return modeValue;
      }

      return this.defaultComponents[mode] || this.defaultComponents["default"];
    },
    isEnqueteAssignedToTarja() {
      return (
        this.producao?.config_tarja_enquete?.id_enquete_tarja === this.enqueteData?.id
      );
    },
    isQRCodeMode() {
      return this.producao?.settings?.enquete?.qr_code ?? false;
    },
    isQRCodeCombinedMode() {
      return this.producao?.settings?.enquete?.qr_code_combined ?? false;
    },
    isTarjaMode() {
      return this.producao?.settings?.enquete?.tarja_mode ?? false;
    },
    barMode() {
      if (this.producao?.config_tarja_enquete) {
        return this.producao.config_tarja_enquete.dsc_orientacao_barra;
      }
      return "horizontal";
    },
    posicaoEnqueteTarja() {
      if (this.producao?.config_tarja_enquete) {
        return this.producao.config_tarja_enquete.dsc_posicao_tarja;
      }
      return "esquerda";
    },
    hideEnqueteTitle() {
      if (this.producao?.config_tarja_enquete) {
        return !this.producao.config_tarja_enquete.flg_display_title;
      }
      return false;
    },
    hideEnqueteOptionTitle() {
      if (this.producao?.config_tarja_enquete) {
        return !this.producao.config_tarja_enquete.flg_display_option_title;
      }
      return false;
    },
    isFullScreen() {
      if (this.producao?.config_tarja_enquete) {
        return this.producao.config_tarja_enquete.flg_is_fullscreen;
      }
      return false;
    },
  },
  methods: {
    getSafeLocalStorage(key, defaultValue = null) {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
      } catch (e) {
        console.error("Error accessing localStorage:", e);
        return defaultValue;
      }
    },
    getSafeLocalStorageNumber(key) {
      try {
        const value = localStorage.getItem(key);
        return value ? Number(value) : null;
      } catch (e) {
        console.error("Error accessing localStorage:", e);
        return null;
      }
    },
    deepEqual(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },
    async fetchEnqueteData() {
      try {
        const enqueteResponse = await apiClient.get(
          `/enquetes/exibicao/${this.codProducao}`
        );
        if (!this.deepEqual(enqueteResponse.data, this.cacheEnqueteData)) {
          this.enqueteData = enqueteResponse.data;
          this.cacheEnqueteData = enqueteResponse.data;
        }
        this.mountTarja = this.enqueteData?.id && this.isEnqueteAssignedToTarja;
      } catch (error) {
        console.error("Error fetching enquete data:", error);
      }
    },
    async getFromApi() {
      if (this.isFetchingData) return;

      this.codProducao =
        this.getSafeLocalStorageNumber("@socialcam/selected_option_production") ||
        parseInt(this.$route.query.cod_producao) ||
        null;

      if (!this.codProducao) {
        console.warn("No production code available");
        return;
      }

      this.isFetchingData = true;
      try {
        const response = await apiClient.get(`/listarDadosProducao/${this.codProducao}`);

        if (!this.deepEqual(response.data, this.cacheProducao)) {
          this.producao = response.data.producao;
          this.cacheProducao = response.data;
        }

        const isNowQRMode = this.producao?.settings?.enquete?.qr_code ?? false;
        const isNowCombinedMode = this.producao?.settings?.enquete?.qr_code_combined ?? false;
        const isNowTarjaMode = this.producao?.settings?.enquete?.tarja_mode ?? false;

        const storeState = this.$store.state.producoes;
        if (
          storeState.enqueteQrCode !== isNowQRMode ||
          storeState.qrCodeCombined !== isNowCombinedMode ||
          storeState.tarjaMode !== isNowTarjaMode
        ) {
          this.$store.dispatch("producoes/setQRCodeMode", {
            enabled: isNowQRMode,
            combined: isNowCombinedMode,
            tarjaMode: isNowTarjaMode,
          });
        }

        await this.fetchEnqueteData();
      } catch (error) {
        console.error("Error fetching production data:", error);
      } finally {
        this.isFetchingData = false;
      }
    },
    getBackgroundColor() {
      if (this.producao?.config_tarja_enquete) {
        return {
          background: `${this.producao.config_tarja_enquete.dsc_hex_background_chroma}`,
        };
      }
      return {};
    },
  },
  watch: {
    isEnqueteAssignedToTarja: {
      handler(newVal) {
        this.mountTarja = this.enqueteData?.id && newVal;
      },
      immediate: true,
    },
    "producao.config_tarja_enquete.id_enquete_tarja": {
      handler() {
        this.mountTarja = this.enqueteData?.id && this.isEnqueteAssignedToTarja;
      },
    },
    "$store.state.producoes.enqueteQrCode": {
      async handler(newVal, oldVal) {
        if (newVal === oldVal) return;
        await this.fetchEnqueteData();
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &.justify-center.align-center {
    justify-content: center;
    align-items: center;
  }
}

.tarjaRow {
  display: grid;
  grid-template-columns: 1fr;
}
</style>
